import * as tslib_1 from "tslib";
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { createErrorModel, isNullOrEmpty } from '@awp/core/utils';
import { RouterNavigateAction, NoopAction } from '@awp/core/ngrx';
import { ApiInsuranceType } from '@awp/quote/models';
import * as actions from './actions';
import { CardService } from '../services';
import { SelectCardTypeFailureAction } from './actions';
import { ContentProvider } from '@awp/content';
var CardCheckEffects = /** @class */ (function () {
    function CardCheckEffects(actions$, cardService, contentProvider) {
        var _this = this;
        this.actions$ = actions$;
        this.cardService = cardService;
        this.contentProvider = contentProvider;
        this.cardSearch$ = this.actions$.pipe(ofType(actions.ActionTypes.BIN_SEARCH), switchMap(function (action) {
            return _this.cardService.getCards(action.payload, action.insuranceType)
                .pipe(map(function (response) {
                return response === 409 ? new actions.AlternativeBinAction() : (response == null || response.length === 0
                    ? new actions.BinSearchNotFoundAction()
                    : new actions.BinSearchSuccessAction(response));
            }), catchError(function (err) { return of(new actions.BinSearchFailureAction(createErrorModel(err))); }));
        }));
        this.cardSelected$ = this.actions$.pipe(ofType(actions.ActionTypes.SELECT_CARD_TYPE), switchMap(function (p) {
            return _this.contentProvider.get('benefitTables.cardBenefits')
                .pipe(map(function (c) {
                var card = c.find(function (item) { return item.cardType === p.payload.card.cardType.code; });
                return {
                    selectedCard: p.payload.card,
                    insuranceType: p.payload.insuranceType,
                    cardContent: card
                };
            }));
        }), map(function (p) {
            if (p.cardContent != null) {
                if (p.insuranceType === ApiInsuranceType.TravelInsurance && !isNullOrEmpty(p.cardContent.travelInsuranceErrorCode)) {
                    return new SelectCardTypeFailureAction(p.insuranceType);
                }
                else if (p.insuranceType === ApiInsuranceType.OtherInsurances && !isNullOrEmpty(p.cardContent.otherInsuranceErrorCode)) {
                    return new SelectCardTypeFailureAction(p.insuranceType);
                }
            }
            if (p.selectedCard.cardType.code != null && p.insuranceType === ApiInsuranceType.TravelInsurance) { // Not sure why this is needing to route here
                return new RouterNavigateAction({ url: ['/', p.selectedCard.clientId, 'quote'] });
            }
            if (p.selectedCard.cardType.code == null) {
                return new SelectCardTypeFailureAction(p.insuranceType);
            }
            return new NoopAction();
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Object)
    ], CardCheckEffects.prototype, "cardSearch$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Object)
    ], CardCheckEffects.prototype, "cardSelected$", void 0);
    return CardCheckEffects;
}());
export { CardCheckEffects };
